module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/bags.204980ed.png";